import { Navigate, useOutlet } from "react-router-dom";
import { useAuth } from "./AuthProvider";

export const LoginLayout = () => {
  const { user } = useAuth();
  const outlet = useOutlet();

  // console.log("LOGin", user);

  if (user) {
    return <Navigate to="/serie" replace />;
  }

  return <div>{outlet}</div>;
};
